import gql from 'graphql-tag';

export const UPDATE_APPOINTMENT = gql`
  mutation ($appointmentId: String, $status: AppointmentStatus) {
    updateAppointment(
      input: {
        appointmentId: $appointmentId,
        status: $status
      }
    ) {
      appointmentId
      status
      subjects {
        user {
          userId
          profile {
            phoneNumber
            firstName
            middleName
            dateOfBirth
            lastName
            title
            gender
            avatar
            isVerified
            isTosAccepted
            isIdEligible
            changePasswordRequired
            policyId
            externalId
          }
        }
        description
      }
      participants {
        user {
          userId
          type
          profile {
            phoneNumber
            firstName
            middleName
            dateOfBirth
            lastName
            title
            gender
            avatar
            timezone
            isVerified
            isTosAccepted
            isIdEligible
            changePasswordRequired
            policyId
            externalId
          }
        }
        participantType
      }
      providerGroupSpecialty {
        id
        name
      }
      allowedConversationTypes

      conversations {
        conversationId
        createdBy
        type
        start
        end
        participants {
          user {
            userId
            profile {
              phoneNumber
              firstName
              middleName
              dateOfBirth
              lastName
              title
              gender
              avatar
              isVerified
              isTosAccepted
              isIdEligible
              changePasswordRequired
              policyId
              externalId
            }
          }
          participantType
        }
        status
        statusHistory {
          status
          createdAt
        }
        call {
          callDeadLineTimestamp
        }
      }
      attachments {
        metaDataId
        mimeType
        encoding
        name
        thumbnail
        downloadRoute
        size
        comment
        status
      }
      schedules {
        startTime
        endTime
        status
      }
      summaries {
        summaryId
        authorId
        description
      }
      prescriptions {
        id
        drug {
          id
          title
        }
        dose
        medicationFrequency
        frequency
        frequencyUnit
        duration
        durationUnit
        comment
      }
      service {
        serviceId
        name
        description
        conversationTypes
        config {
          providerSelectionType
          subjectsEnabled
          subjectsRequired
          subjectsRequireIdentifiedUsers
          videoRecordingEnabled
          audioRecordingEnabled
          fileUploadsEnabled
          summaryEnabled
          prescriptionsEnabled
          selfServiceEnabled
          overlappingSchedules
        }
      }
    }
  }
`;
